import { render, staticRenderFns } from "./PT255FAQListParts.vue?vue&type=template&id=160288a6&"
import script from "./PT255FAQListParts.vue?vue&type=script&lang=js&"
export * from "./PT255FAQListParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports